module.exports = __webpack_public_path__ + "img/matt-rock-480-60.1bd78a4c.jpg";